"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "renderFlatTree_unstable", {
    enumerable: true,
    get: function() {
        return renderFlatTree_unstable;
    }
});
const _Tree = require("../../Tree");
const renderFlatTree_unstable = _Tree.renderTree_unstable;
